import * as types from 'store/actions/types';
import services from 'services/services';
import { AxiosError } from 'axios';
import { Dispatch, AnyAction } from 'redux';

// Import helpers
import { getErrorCodeResults } from 'helpers/error_code_api';

// Import types
import type { PinFormValues } from 'types/views/parental_control';

type Params = {
	values: PinFormValues;
	isParental?: boolean;
	callback?: VoidFunction;
};

// ******************** UPDATE PIN NUMBER ********************
export const updatePinNumber =
	({ values, isParental = true, callback = () => {} }: Params) =>
	async (dispatch: Dispatch<AnyAction>) => {
		try {
			dispatch({
				type: types.UPDATE_PIN_NUMBER_LOADING,
				payload: true
			});

			const { pin, pin_confirmation, old_pin } = values;

			const url = isParental ? '/subscriber/parental/pin' : '/subscriber/payments/pin';

			await services.put(url, {
				pin,
				pin_confirmation,
				old_pin
			});

			dispatch({
				type: types.UPDATE_PIN_NUMBER_SUCCESS,
				payload: true
			});
			callback();
		} catch (error: unknown) {
			if (error instanceof AxiosError) {
				if (error.response) {
					const { codeErrorMessage } = getErrorCodeResults(error);

					error.response.data.message = codeErrorMessage;

					dispatch({
						type: types.UPDATE_PIN_NUMBER_ERROR,
						payload: error.response
					});
				}
			}
		}
	};

export const clearPinData = () => (dispatch: Dispatch<AnyAction>) => {
	dispatch({
		type: types.UPDATE_PIN_CLEAR_PIN_DATA,
		payload: true
	});
};
